var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "mb-3", attrs: { outlined: "" } },
    [
      _c(
        "v-card-title",
        { staticClass: "text-subtitle-1 d-flex align-center" },
        [
          _c("v-icon", { attrs: { left: "", small: "" } }, [
            _vm._v("mdi-source-branch"),
          ]),
          _vm._v(" Trilha da Turma "),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { small: "", color: "primary", disabled: !_vm.groupId },
              on: { click: _vm.openDialog },
            },
            [
              _c("v-icon", { attrs: { left: "", small: "" } }, [
                _vm._v("mdi-plus"),
              ]),
              _vm._v(" Vincular turma "),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-card-subtitle", { staticClass: "pb-2" }, [
        _vm._v(
          " Continuidade desta turma em outros períodos letivos. Vincule turmas equivalentes para preservar o histórico de disciplinas cursadas. "
        ),
      ]),
      _c(
        "v-card-text",
        [
          !_vm.groupId
            ? _c("v-alert", { attrs: { type: "info", text: "", dense: "" } }, [
                _vm._v(" Salve a turma antes de gerenciar a trilha. "),
              ])
            : [
                _c("v-data-table", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.state.linked_groups || [],
                    loading: _vm.loading,
                    "hide-default-footer": "",
                    "items-per-page": 50,
                    dense: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.work_time",
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.work_time ? item.work_time.name : "—"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.name",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "span",
                            { class: { "font-weight-bold": item.is_current } },
                            [_vm._v(" " + _vm._s(item.name) + " ")]
                          ),
                          item.is_current
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ml-2",
                                  attrs: { "x-small": "", color: "primary" },
                                },
                                [_vm._v(" atual ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item.curriculum",
                      fn: function ({ item }) {
                        return [
                          item.curriculum
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "span",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "curriculum-cell",
                                                  },
                                                  "span",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item.curriculum.code ||
                                                        item.curriculum.name
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(item.curriculum.name)),
                                  ]),
                                ]
                              )
                            : _c("span", { staticClass: "grey--text" }, [
                                _vm._v("—"),
                              ]),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  text: "",
                                                  color: "red",
                                                  loading:
                                                    _vm.busyId === item.id,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.confirmUnlink(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-link-variant-off")]
                                            ),
                                            _vm._v(" Remover da trilha "),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " Remove apenas esta turma da trilha. As demais permanecem vinculadas. "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.suggestionItems.length || _vm.suggestionMeta.total > 0
                  ? _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-subtitle-2 mb-2 d-flex align-center",
                          },
                          [
                            _c("v-icon", { attrs: { small: "", left: "" } }, [
                              _vm._v("mdi-lightbulb-outline"),
                            ]),
                            _vm._v(
                              " Sugestões automáticas (" +
                                _vm._s(_vm.suggestionMeta.total) +
                                ") "
                            ),
                            _c("v-spacer"),
                            _c("v-select", {
                              staticStyle: { "max-width": "130px" },
                              attrs: {
                                items: [5, 10, 20, 50],
                                dense: "",
                                outlined: "",
                                "hide-details": "",
                                label: "Por página",
                              },
                              on: { change: _vm.onPerPageChange },
                              model: {
                                value: _vm.suggestionsPerPage,
                                callback: function ($$v) {
                                  _vm.suggestionsPerPage = $$v
                                },
                                expression: "suggestionsPerPage",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-list",
                          {
                            staticClass: "suggestions-list",
                            attrs: { dense: "", outlined: "", rounded: "" },
                          },
                          [
                            _vm._l(_vm.suggestionItems, function (s, idx) {
                              return [
                                idx > 0
                                  ? _c("v-divider", { key: "div-" + s.id })
                                  : _vm._e(),
                                _c(
                                  "v-list-item",
                                  {
                                    key: s.id,
                                    staticClass: "suggestion-row",
                                    on: {
                                      click: function ($event) {
                                        return _vm.linkOne(s.id)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                s.work_time
                                                  ? s.work_time.name
                                                  : "?"
                                              ) +
                                              " — " +
                                              _vm._s(s.name) +
                                              " "
                                          ),
                                          _c(
                                            "small",
                                            { staticClass: "grey--text" },
                                            [_vm._v("(" + _vm._s(s.code) + ")")]
                                          ),
                                        ]),
                                        _c("v-list-item-subtitle", [
                                          _vm._v(
                                            " " +
                                              _vm._s(s.students || 0) +
                                              " alunos "
                                          ),
                                          s.curriculum
                                            ? _c("span", [
                                                _vm._v(" · matriz "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      s.curriculum.code ||
                                                        s.curriculum.name
                                                    )
                                                  ),
                                                ]),
                                              ])
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-action",
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              outlined: "",
                                              color: "primary",
                                              loading: _vm.busyId === s.id,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.linkOne(s.id)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  left: "",
                                                },
                                              },
                                              [_vm._v("mdi-link-variant-plus")]
                                            ),
                                            _vm._v(" Vincular "),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm.suggestionMeta.last_page > 1
                          ? _c(
                              "div",
                              { staticClass: "d-flex justify-center mt-3" },
                              [
                                _c("v-pagination", {
                                  attrs: {
                                    length: _vm.suggestionMeta.last_page,
                                    "total-visible": 7,
                                  },
                                  on: { input: _vm.onPageChange },
                                  model: {
                                    value: _vm.suggestionsPage,
                                    callback: function ($$v) {
                                      _vm.suggestionsPage = $$v
                                    },
                                    expression: "suggestionsPage",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-alert",
                          {
                            staticClass: "mt-3 suggestions-footnote",
                            attrs: {
                              dense: "",
                              text: "",
                              border: "left",
                              color: "info",
                              icon: "mdi-information-outline",
                            },
                          },
                          [
                            _c("div", { staticClass: "text-caption" }, [
                              _c("strong", { staticClass: "d-block mb-1" }, [
                                _vm._v("Como geramos estas sugestões"),
                              ]),
                              _vm._v(" Turmas com "),
                              _c("strong", [
                                _vm._v("mesmo curso, campus e turno"),
                              ]),
                              _vm._v(" da turma atual, em "),
                              _c("strong", [
                                _vm._v("períodos letivos anteriores"),
                              ]),
                              _vm._v(
                                ", que ainda não fazem parte de outra trilha. A lista é ordenada por "
                              ),
                              _c("strong", [_vm._v("período letivo")]),
                              _vm._v(
                                " (mais recente primeiro), com desempate por nome da turma. "
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
          _vm.groupId
            ? _c("trail-link-dialog", {
                attrs: {
                  show: _vm.dialog,
                  "group-id": _vm.groupId,
                  "course-id": _vm.courseId,
                  "current-work-time-id": _vm.currentWorkTimeId,
                  "excluded-ids": _vm.excludedIds,
                  "excluded-names": _vm.excludedNames,
                },
                on: {
                  "update:show": function ($event) {
                    _vm.dialog = $event
                  },
                  link: _vm.onLinkFromDialog,
                },
              })
            : _vm._e(),
          _c("emc-alert-modal", {
            attrs: {
              text: "Remover esta turma da trilha? Apenas ela será desvinculada — as demais permanecem juntas.",
              show: _vm.confirmDialog,
            },
            on: {
              "update:show": function ($event) {
                _vm.confirmDialog = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "actions",
                fn: function () {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "error" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.doUnlink()
                          },
                        },
                      },
                      [
                        _vm._v(" Remover da trilha "),
                        _c("v-icon", { attrs: { right: "", dark: "" } }, [
                          _vm._v("mdi-link-variant-off"),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }